/* eslint-disable react/jsx-key */

import React from 'react';
import { createIcon } from '@chakra-ui/icons';

export const FlagIconKazakhstan = createIcon({
  displayName: 'FlagIconKazakhstan',
  viewBox: '0 0 640 480',
  path: [
    <path fill="#00afca" d="M0 0h640v480H0z" />,
    <path fill="#ffc600" d="M0 0h80v480H0z" />,
    <circle fill="#ffc600" cx="320" cy="240" r="60" />,
    <path
      fill="#ffc600"
      d="M320 200c-22 0-40 18-40 40s18 40 40 40 40-18 40-40-18-40-40-40zm0 20c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20z"
    />,
  ],
});
